// import React, {
//   createContext,
//   useContext,
//   useRef,
//   useState,
//   useEffect,
// } from "react";
// import { useNavigate } from "react-router-dom";
// import { SOCKET_BASE_URL } from "../utils/socketUrl";
// import { useAuth } from "./auth";
// import { current } from "@reduxjs/toolkit";
// import { decode } from "@msgpack/msgpack";

// const UseWebSocketContext = createContext(null);
// export function useWebSocket() {
//   return useContext(UseWebSocketContext);
// }

// export const sendGlobalWS = (message) => {
//   const socketRef = window.globalSocket;
//   const socket = socketRef?.current;
//   if (socket && socket.readyState === WebSocket.OPEN) {
//     socket.send(JSON.stringify(message));
//   } else {
//     console.warn(" Socket not open");
//   }
// };

// export const closeWebSocket = () => {
//   const socketRef = window.globalSocket;
//   const socket = socketRef?.current;
//   if (socket && socket.readyState === WebSocket.OPEN) {
//     socket.close();
//   }
// };

// export function WebSocketProvider({ children }) {
//   const socketRef = useRef(null);
//   // expose global ref for compatibility

//   window.globalSocket = socketRef;

//   const { getLoginToken, getGoogleAuthToken } = useAuth();
//   const navigate = useNavigate();

//   const [wsData, setWsData] = useState(null);
//   const [balance, setBalance] = useState(null);
//   const [alertsData, setAlertsData] = useState([]);
//   const [positionsData, setPositionsData] = useState([]);
//   const [ordersData, setOrdersData] = useState([]);

//   const [errorMessage, setErrorMessage] = useState("");

//   const [eventsData, setEventsData] = useState([]);
//   const [isSocketReady, setIsSocketReady] = useState(false);

//   const token = getLoginToken() || getGoogleAuthToken();

//   const reconnectAttemptsRef = useRef(0);
//   const maxReconnectAttempts = 5;
//   const reconnectTimeoutRef = useRef(null);

//   const [messege, setMessage] = useState("");

//   window.shouldReconnect = true;

//   if (!window.__wsEventAttached) {
//     window.addEventListener("visibilitychange", () => {
//       if (document.visibilityState === "visible") {
//         if (
//           !socketRef.current ||
//           socketRef.current.readyState !== WebSocket.OPEN
//         ) {
//           if (token) {
//             connectWebSocket(token);
//           }
//         }
//       }
//     });

//     window.addEventListener("focus", () => {
//       if (
//         !socketRef.current ||
//         socketRef.current.readyState !== WebSocket.OPEN
//       ) {
//         if (token) {
//           connectWebSocket(token);
//         }
//       }
//     });

//     window.__wsEventAttached = true;
//   }

//   useEffect(() => {
//     if (token) {
//       connectWebSocket(token);
//     }
//   }, []);

//   const connectWebSocket = async (loginKey) => {
//     return new Promise((resolve) => {
//       if (!loginKey) {
//         console.warn("⚠️ Token missing");
//         window.shouldReconnect = false; // stop reconnection
//         navigate("/login");
//         return;
//       }

//       if (
//         socketRef.current &&
//         (socketRef.current.readyState === WebSocket.OPEN ||
//           socketRef.current.readyState === WebSocket.CONNECTING)
//       ) {
//         return;
//       }

//       // Close previous if exists
//       if (socketRef.current) {
//         try {
//           socketRef.current.onclose = null; // Prevent triggering your onclose handler again
//           socketRef.current.close();
//         } catch (err) {
//           console.warn("Socket already closed or failed to close:", err);
//         } finally {
//           socketRef.current = null;
//         }
//       }

//       if (window.globalSocket?.current) {
//         try {
//           window.globalSocket.current.onclose = null;
//           window.globalSocket.current.close();
//         } catch (err) {
//           console.warn("Global socket already closed or failed to close:", err);
//         } finally {
//           window.globalSocket.current = null;
//         }
//       }

//       try {
//         window.shouldReconnect = true;
//         const socket = new WebSocket(`${SOCKET_BASE_URL}/${loginKey}`);
//         socketRef.current = socket;
//         window.globalSocket = socketRef;

//         socket.onopen = async () => {
//           console.log("Login Token", loginKey);
//           console.log("✅ WebSocket connected");

//           resolve(true);

//           setIsSocketReady(true);

//           setTimeout(() => {
//             send(socketRef.current, { r: "profile" });
//           }, 1000);

//           setTimeout(() => {
//             send(socketRef.current, { r: "balance" });
//           }, 1000);

//           setTimeout(() => {
//             send(socketRef.current, { r: "positions" });
//           }, 1000);

//           //  setTimeout(() => {
//           //   send(socketRef.current, { r: "alerts" });
//           // }, 1000);
//         };

//         socket.onmessage = async (event) => {
//           let response;

//           if (event.data instanceof Blob) {
//             const buffer = await event.data.arrayBuffer();
//             response = decode(new Uint8Array(buffer));
//           } else if (event.data instanceof ArrayBuffer) {
//             response = decode(new Uint8Array(event.data));
//           } else {
//             console.warn("Unknown WebSocket data type:", typeof event.data);
//             return;
//           }

//           console.log(" Decoded MessagePack response:", response);

//           // console.log(" Response d", response?.d);

//           if (response?.i === 401 && response?.d === "Access denied!") {
//             setErrorMessage(response?.d);

//             sessionStorage.setItem("denied", true);

//             // console.log("acess denied occour", errorMessage)

//             clearInterval();

//             closeWebSocket();

//             return;
//           }

//           if (
//             response?.i === 429 &&
//             response?.d === "Too Many Request Try Again!"
//           ) {
//             setErrorMessage(response?.d);

//             reconnect();
//             return;
//           }

//           if (
//             response?.i === 414 &&
//             response?.d === "High Length Not Acceptable!"
//           ) {
//             setErrorMessage(response?.d);
//             localStorage.removeItem("session-token");
//             localStorage.removeItem("sec_key");
//             localStorage.removeItem("login_mail");
//             localStorage.removeItem("sec_key");

//             localStorage.removeItem("google_auth_token");
//             localStorage.removeItem("user");

//             sessionStorage.removeItem("sessionKey");

//             sessionStorage.setItem("denied", true);
//             console.log("too many bad request occour", errorMessage);

//             logoutCleanup();
//             closeWebSocket();

//             return;
//           }

//           // Handle profile
//           if (response?.i === 200 && response.d?.profile) {
//             setWsData(response.d.profile);
//             // console.log("profilereaponse", response.d?.profile)
//           }

//           // Handle alerts
//           if (response?.i === 200 && response?.d) {
//             const data =
//               typeof response.d === "string"
//                 ? JSON.parse(response.d)
//                 : response.d;

//             const incoming = data.alerts;
//             // console.log("messes comming", data.msg)

//             // console.log("alet incoming", incoming)

//             if (Array.isArray(incoming)) {
//               setAlertsData(incoming);
//             } else {
//               setAlertsData([]);
//               console.warn("No alerts found for selected date");
//             }
//           }

//           // if (response?.i === 200 && response.d) {
//           //   const data = typeof response.d === "string" ? JSON.parse(response.d) : response.d;

//           //   if (data.orders && Array.isArray(data.orders)) {
//           //     console.log("Orders snapshot:", data.orders);
//           //     setOrdersData(data.orders);

//           //   }
//           //    else {
//           //     console.log("No orders in this message");
//           //     // Optional: don't reset state if no orders
//           //     // setOrdersData([]);
//           //   }
//           // }

//           //orderdata
//           // if (response?.i === 200) {
//           //  const data = typeof response.d === "string" ? JSON.parse(response.d) : response.d;
//           //   if (data) {

//           //     // const incoming = data.alerts;

//           //     const incoming = data.orders;
//           //     // console.log("snapshot orders:", incoming);
//           //     setOrdersData(Array.isArray(incoming) ? incoming : []);

//           //   }

//           //   if (data.order) {
//           //     const newRow = data.order
//           //     console.log("single new order:", newRow);

//           //     setOrdersData((prev) => {
//           //       const current = Array.isArray(prev) ? prev : [];

//           //       // Remove duplicate by order_id
//           //       const filtered = current.filter(
//           //         (order) =>
//           //           order.order_id?.toUpperCase() !== newRow.order_id?.toUpperCase()
//           //       );

//           //       return [newRow, ...filtered];
//           //     });
//           //   }

//           //   // 3️⃣ Order event update
//           //   if (data?.order_event) {
//           //     const { id, status } = response.d.order_event;

//           //     setOrdersData((prev) => {
//           //       if (!Array.isArray(prev)) return prev;

//           //       return prev.map((order) =>
//           //         order.order_id?.toUpperCase() === id?.toUpperCase()
//           //           ? { ...order, status }
//           //           : order
//           //       );
//           //     });
//           //   }
//           // }

//           if (response?.i === 200) {
//             const data =
//               typeof response.d === "string"
//                 ? JSON.parse(response.d)
//                 : response.d;

//             if (!data) return;

//             // 1️⃣ Full orders snapshot
//             if (Array.isArray(data.orders)) {
//               setOrdersData(data.orders);
//               // console.log("Full orders snapshot updated:", data.orders);
//             }

//             // 2️⃣ Single new order row
//             // if (data.order) {
//             //   const newRow = data.order;
//             //   // console.log("Single new order received:", newRow);

//             //   setOrdersData((prev) => {
//             //     const current = Array.isArray(prev) ? prev : [];

//             //     // Remove duplicate by order_id
//             //     const filtered = current.filter(
//             //       (order) =>
//             //         order.order_id?.toUpperCase() !== newRow.order_id?.toUpperCase()
//             //     );

//             //     return [newRow, ...filtered]; // Add new order on top
//             //   });
//             // }

//             // 3️⃣ Update existing order (order_event)
//             // if (data.order_event) {
//             //   const { id, status } = data.order_event;

//             //   setOrdersData((prev) => {
//             //     if (!Array.isArray(prev)) return prev;

//             //     const updated = prev.map((order) =>
//             //       order.order_id?.toUpperCase() === id?.toUpperCase()
//             //         ? { ...order, status } // update status
//             //         : order
//             //     );

//             //     // console.log("Order updated:", { id, status });
//             //     return updated;
//             //   });
//             // }
//           }

//           if (response?.data?.order) {
//             const newRow = response?.data?.order;

//             setOrdersData((prev) => {
//               const current = Array.isArray(prev) ? prev : [];

//               // Remove duplicate by order_id
//               const filtered = current.filter(
//                 (order) =>
//                   order.order_id?.toUpperCase() !==
//                   newRow.order_id?.toUpperCase(),
//               );

//               return [newRow, ...filtered]; // Add new order on top
//             });
//           }

//           // if (response?.data?.order_event) {
//           //   const { id, status, fill_price } = response?.data?.order_event;

//           //   setOrdersData((prev) => {
//           //     if (!Array.isArray(prev)) return prev;

//           //     const updated = prev.map((order) =>
//           //       order.order_id?.toUpperCase() === id?.toUpperCase()
//           //         ? { ...order, status, fill_price } // update status
//           //         : order
//           //     );

//           //     return updated;
//           //   });
//           // }

//           function sleep(ms) {
//             return new Promise((resolve) => setTimeout(resolve, ms));
//           }

//           if (response?.data?.order_event) {
//             const { id, status, price } = response.data.order_event;
//             (async () => {
//               await sleep(1);

//               setOrdersData((prevOrders) => {
//                 if (!Array.isArray(prevOrders)) return prevOrders;

//                 return prevOrders.map((order) => {
//                   // Ensure both IDs exist and match (case-insensitive)
//                   if (
//                     order?.order_id &&
//                     id &&
//                     order.order_id.toString().toUpperCase() ===
//                       id.toString().toUpperCase()
//                   ) {
//                     return {
//                       ...order,
//                       status: status ?? order.status, // Update status if available
//                       fill_price: price ?? order.fill_price, // Update fill_price if available
//                     };
//                   }
//                   return order;
//                 });
//               });
//             })();
//           }

//           // if (response?.i === 200) {
//           //   //  Fresh list of positions
//           //     const data = typeof response.d === "string" ? JSON.parse(response.d) : response.d;
//           //   if (data) {

//           //   const incoming = data.positions;
//           //     // const incoming = response.d.positions;
//           //     console.log("Positions ", incoming);
//           //     // setPositionsData(Array.isArray(incoming) ? incoming : []);

//           //     if (Array.isArray(incoming)) {
//           //       const sorted = [...incoming].sort((a, b) => {
//           //         if (a.pos === 0 && b.pos !== 0) return 1;
//           //         if (a.pos !== 0 && b.pos === 0) return -1;
//           //         return 0;
//           //       });

//           //       setPositionsData(sorted);
//           //     } else {
//           //       setPositionsData([]);
//           //     }

//           //     // setPositionsData((prev) => [...incoming, ...(Array.isArray(prev) ? prev : [])]);

//           //   }

//           //   //  Single new row → always add on top
//           //   if (data?.position) {
//           //     const newRow = response.d.position;
//           //     // console.log("new pos", newRow)
//           //     setPositionsData((prev) => {
//           //       if (!Array.isArray(prev)) return [newRow];

//           //       // Prevent duplicate rows (same trading_symbol)
//           //       const filtered = prev.filter(
//           //         (pos) =>
//           //           pos.trading_symbol?.toUpperCase() !==
//           //           newRow.trading_symbol?.toUpperCase()
//           //       );

//           //       return [newRow, ...filtered];
//           //     });
//           //   }

//           //   //  Update existing row fields (unrealized, ltp)
//           //   if (data.position_event) {
//           //     const { symbol, unrealized_pnl, ltp } = response.d.position_event;

//           //     (async () => {
//           //       await sleep(1);
//           //       setPositionsData((prev) => {
//           //         if (!Array.isArray(prev)) return prev;

//           //         return prev.map((pos) => {
//           //           // if (pos.trading_symbol?.toUpperCase() === symbol?.toUpperCase()) {
//           //           if (pos.trading_symbol?.toUpperCase().trim() === symbol?.toUpperCase().trim()) {

//           //             return { ...pos, unrealized: unrealized_pnl, ltp: ltp };
//           //           }
//           //           return pos;
//           //         });
//           //       });
//           //     })();
//           //   }
//           // }

//           if (response?.i === 200) {
//             // Parse data safely

//             const posdata =
//               typeof response.d === "string"
//                 ? JSON.parse(response.d)
//                 : response.d;

//             if (!posdata) return;

//             if (Array.isArray(posdata.positions)) {
//               const sorted = [...posdata.positions].sort((a, b) => {
//                 if (a.pos === 0 && b.pos !== 0) return 1;
//                 if (a.pos !== 0 && b.pos === 0) return -1;
//                 return 0;
//               });

//               setPositionsData(sorted);
//               // console.log("Full positions list updated:", sorted);
//             }
//           }

//           // console.log("unrea",response?.data?.position_event?.unrealized_pnl)

//           if (response?.data?.position) {
//             const newRow = response?.data?.position;

//             setPositionsData((prev) => {
//               if (!Array.isArray(prev)) {
//                 // console.log("New row added:", newRow);
//                 return [newRow];
//               }

//               const filtered = prev.filter(
//                 (pos) =>
//                   pos.trading_symbol?.toUpperCase().trim() !==
//                   newRow.trading_symbol?.toUpperCase().trim(),
//               );

//               // console.log("New row added:", newRow);
//               return [newRow, ...filtered];
//             });
//           }

//           if (response?.data?.position_event) {
//             const { symbol, unrealized_pnl, ltp } =
//               response?.data?.position_event;
//             (async () => {
//               await sleep(1);
//               setPositionsData((prev) => {
//                 if (!Array.isArray(prev)) return prev;

//                 let updated = prev.map((pos) =>
//                   pos.trading_symbol?.toUpperCase().trim() ===
//                   symbol?.toUpperCase().trim()
//                     ? {
//                         ...pos,
//                         unrealized: Number(unrealized_pnl),
//                         ltp: Number(ltp),
//                       }
//                     : pos,
//                 );

//                 const exists = prev.some(
//                   (pos) =>
//                     pos.trading_symbol?.toUpperCase().trim() ===
//                     symbol?.toUpperCase().trim(),
//                 );
//                 if (!exists)
//                   updated.unshift({
//                     trading_symbol: symbol,
//                     unrealized: Number(unrealized_pnl),
//                     ltp: Number(ltp),
//                   });

//                 return [...updated]; // ensure new array reference
//               });
//             })();
//           }

//           // console.log("message" ,response?.data?.msg)
//           if (response?.data?.msg) {
//             const msg = response?.data?.msg;

//             setMessage(msg);
//           }

//           // Handle event Data

//           // if (response?.i === 200) {
//           //   const data =
//           //     typeof response === "string" ? JSON.parse(response) : response;
//           //   // const incomingevents = response.d?.events;

//           //   if (!data) {
//           //     return
//           //   }
//           //   const incomingevents = data.events
//           //     console.log("events", incomingevents);
//           //   if (Array.isArray(incomingevents)) {
//           //     console.log("events", incomingevents);

//           //     setEventsData((prev) => {

//           //       const merged = [...prev];

//           //       incomingevents.forEach((newEvent) => {
//           //         const index = merged.findIndex((e) => e.id === newEvent.id);
//           //         if (index !== -1) {

//           //           merged[index] = newEvent;
//           //         } else {
//           //           // Add new event
//           //           merged.push(newEvent);
//           //         }
//           //       });

//           //       return merged;
//           //     });

//           //   } else {
//           //     console.warn(" No Event found for selected date");
//           //   }
//           // }

//           if (response?.events && Array.isArray(response.events)) {
//             const incomingEvents = response.events;

//             setEventsData((prev) => {
//               const merged = [...prev];

//               incomingEvents.forEach((newEvent) => {
//                 let parsedEvent = { ...newEvent };

//                 try {
//                   if (typeof newEvent.event === "string") {
//                     parsedEvent.event = JSON.parse(
//                       newEvent.event
//                         .replace(/'/g, '"') // Replace single quotes
//                         .replace(/\bFalse\b/g, "false")
//                         .replace(/\bTrue\b/g, "true"),
//                     );
//                   }
//                 } catch (err) {
//                   console.warn(
//                     "Failed to parse event string:",
//                     newEvent.event,
//                     err,
//                   );
//                 }

//                 const index = merged.findIndex((e) => e.id === parsedEvent.id);
//                 if (index !== -1) merged[index] = parsedEvent;
//                 else merged.push(parsedEvent);
//               });

//               // console.log("✅ Updated Events:", merged);
//               return merged;
//             });
//           }

//           // console.log("updated", response?.data?.balance?.[0]?.balance)
//           // console.log(
//           //   "updated balance",
//           //   response?.d?.balance?.[0]?.balance || response?.data?.balance?.[0]?.balance
//           // );

//           if (response?.d?.balance || response?.data) {
//             let balanceArray = null;

//             // Case 1: Normal object under response.d
//             if (response.d?.balance) {
//               balanceArray = response.d.balance;
//             }
//             // Case 2 or 3: Data under response.data (can be string or object)
//             else if (response.data) {
//               const parsedData =
//                 typeof response.data === "string"
//                   ? JSON.parse(response.data)
//                   : response.data;

//               balanceArray = parsedData?.balance;
//             }

//             // Extract first item if array
//             const balanceData = Array.isArray(balanceArray)
//               ? balanceArray[0]
//               : balanceArray;

//             if (balanceData) {
//               setBalance((prev) => ({
//                 ...prev,
//                 balance: balanceData.balance,
//                 account: balanceData.account,
//               }));

//               console.log(
//                 "Updated balance:",
//                 balanceData.account,
//                 balanceData.balance,
//               );
//             }
//           }
//         };

//         //   if (response?.i === 200 && response.d?.balance) {
//         //     // Use the latest balance (last element)
//         //     const balanceArray = response.d.balance;

//         //     if (Array.isArray(balanceArray) && balanceArray.length > 0) {
//         //       const latestBalance = balanceArray[balanceArray.length - 1]; // last element

//         //       setBalance((prev) => ({
//         //         ...prev,
//         //         balance: latestBalance.balance,
//         //         account: latestBalance.account,
//         //       }));

//         //       // console.log("Balance updated:", latestBalance);
//         //     } else {
//         //       console.warn("Balance array is empty");
//         //     }
//         //   }
//         // }

//         socket.onerror = (error) => {
//           console.error("❌ WebSocket error:", error);
//           resolve(false);
//           reconnect();
//         };

//         socket.onclose = (event) => {
//           console.log("⚠️ WebSocket closed:", event);

//           // Stop further reconnect attempts if user is logged out
//           if (!token || !window.shouldReconnect) {
//             console.log(
//               " WebSocket will not reconnect because token is missing or logout triggered.",
//             );
//             return;
//           }
//         };
//       } catch (err) {
//         console.error("❌ WebSocket connection failed:", err);
//         resolve(false);
//         // reconnect()
//       }
//     });
//   };

//   const reconnect = () => {
//     if (reconnectAttemptsRef.current < maxReconnectAttempts) {
//       reconnectAttemptsRef.current += 1;
//       console.warn(`Attempting reconnect #${reconnectAttemptsRef.current}...`);
//       reconnectTimeoutRef.current = setTimeout(() => {
//         if (token && window.shouldReconnect) {
//           connectWebSocket(token);
//         }
//       }, 2000);
//     } else {
//       console.error("Max reconnect attempts reached.");
//     }
//   };

//   const send = (socket, message) => {
//     if (socket && socket.readyState === WebSocket.OPEN) {
//       socket.send(JSON.stringify(message));
//     } else {
//       console.warn("⚠️ Socket not open to send", message);
//     }
//   };

//   const logoutCleanup = () => {
//     //  Close WebSocket
//     if (socketRef.current) {
//       socketRef.current.close();
//       socketRef.current = null;
//     }

//     setWsData(null);
//     setBalance(null);
//     setAlertsData([]);
//     setEventsData([]);
//     setErrorMessage("");
//     setOrdersData([]);
//     setPositionsData([]);
//     setMessage("");
//   };

//   return (
//     <UseWebSocketContext.Provider
//       value={{
//         connectWebSocket,
//         wsData,
//         balance,
//         setBalance,
//         setWsData,
//         errorMessage,
//         logoutCleanup,
//         alertsData,
//         setAlertsData,
//         ordersData,
//         setOrdersData,
//         positionsData,
//         setPositionsData,
//         send,
//         socketRef,
//         isSocketReady,
//         setErrorMessage,
//         eventsData,
//         setEventsData,
//         messege,
//         setMessage,
//         closeWebSocket,
//       }}
//     >
//       {children}
//     </UseWebSocketContext.Provider>
//   );
// }
import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import { SOCKET_BASE_URL } from "../utils/socketUrl";
import { useAuth } from "./auth";
import { decode } from "@msgpack/msgpack";
import { toast } from "react-toastify";

const UseWebSocketContext = createContext(null);
export function useWebSocket() {
  return useContext(UseWebSocketContext);
}

export const sendGlobalWS = (message) => {
  const socketRef = window.globalSocket;
  const socket = socketRef?.current;
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(message));
  } else {
    console.warn(" Socket not open");
  }
};

export const closeWebSocket = () => {
  const socketRef = window.globalSocket;
  const socket = socketRef?.current;
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.close();
  }
};

export function WebSocketProvider({ children }) {
  const socketRef = useRef(null);
  window.globalSocket = socketRef;

  const { getLoginToken, getGoogleAuthToken } = useAuth();
  const navigate = useNavigate();

  const [wsData, setWsData] = useState(null);
  const [balance, setBalance] = useState(null);
  const [alertsData, setAlertsData] = useState([]);
  const [positionsData, setPositionsData] = useState([]);
  const [ordersData, setOrdersData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [eventsData, setEventsData] = useState([]);
  const [isSocketReady, setIsSocketReady] = useState(false);
  const [messege, setMessage] = useState("");

  const token = getLoginToken() || getGoogleAuthToken();
  const reconnectAttemptsRef = useRef(0);
  const maxReconnectAttempts = 5;
  const reconnectTimeoutRef = useRef(null);

  window.shouldReconnect = true;

  if (!window.__wsEventAttached) {
    window.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
          if (token) {
            connectWebSocket(token);
          }
        }
      }
    });

    window.addEventListener("focus", () => {
      if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
        if (token) {
          connectWebSocket(token);
        }
      }
    });

    window.__wsEventAttached = true;
  }

  useEffect(() => {
    if (token) {
      connectWebSocket(token);
    }
  }, []);

  const connectWebSocket = async (loginKey) => {
    return new Promise((resolve) => {
      if (!loginKey) {
        console.warn("⚠️ Token missing");
        window.shouldReconnect = false;
        navigate("/login");
        return;
      }

      if (socketRef.current && (socketRef.current.readyState === WebSocket.OPEN ||
          socketRef.current.readyState === WebSocket.CONNECTING)) {
        return;
      }

      if (socketRef.current) {
        try {
          socketRef.current.onclose = null;
          socketRef.current.close();
        } catch (err) {
          console.warn("Socket already closed:", err);
        } finally {
          socketRef.current = null;
        }
      }

      if (window.globalSocket?.current) {
        try {
          window.globalSocket.current.onclose = null;
          window.globalSocket.current.close();
        } catch (err) {
          console.warn("Global socket already closed:", err);
        } finally {
          window.globalSocket.current = null;
        }
      }

      try {
        window.shouldReconnect = true;
        const socket = new WebSocket(`${SOCKET_BASE_URL}/${loginKey}`);
        socketRef.current = socket;
        window.globalSocket = socketRef;

        socket.onopen = async () => {
          console.log("Login Token", loginKey);
          console.log("✅ WebSocket connected");
          resolve(true);
          setIsSocketReady(true);

          setTimeout(() => send(socketRef.current, { r: "profile" }), 1000);
          setTimeout(() => send(socketRef.current, { r: "balance" }), 1000);
          setTimeout(() => send(socketRef.current, { r: "positions" }), 1000);
        };

        socket.onmessage = async (event) => {
          let response;

          if (event.data instanceof Blob) {
            const buffer = await event.data.arrayBuffer();
            response = decode(new Uint8Array(buffer));
          } else if (event.data instanceof ArrayBuffer) {
            response = decode(new Uint8Array(event.data));
          } else {
            console.warn("Unknown WebSocket data type:", typeof event.data);
            return;
          }

          console.log("Decoded MessagePack response:", response);

          // ✅ HANDLE 401 - Access Denied - Redirect to Login
          if (response?.i === 401 && response?.d === "Access denied!") {
            console.error("❌ 401 Unauthorized - Access Denied!");
            toast.error("Session expired! Please login again.");
            
            // ✅ Set error message for ProtectedRoutes
            setErrorMessage("Access denied!");
            
            // Clear all storage
            localStorage.clear();
            sessionStorage.clear();
            
            // Close WebSocket
            if (socketRef.current) {
              socketRef.current.close();
              socketRef.current = null;
            }
            
            // Redirect to login page
            setTimeout(() => {
              window.location.href = "/login";
            }, 1000);
            return;
          }

          // ✅ HANDLE 429 - Too Many Requests
          if (response?.i === 429 && response?.d === "Too Many Request Try Again!") {
            console.warn("⚠️ 429 Too Many Requests - Rate limit exceeded!");
            toast.warning("Too many requests! Please wait a moment.");
            
            // ✅ Set error message for ProtectedRoutes
            setErrorMessage("Too Many Request Try Again!");
            
            // Auto retry after 5 seconds
            setTimeout(() => {
              if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
                send(socketRef.current, { r: "profile" });
              }
              // Clear error message after retry
              setErrorMessage("");
            }, 5000);
            return;
          }

          // ✅ HANDLE 414 - High Length Not Acceptable
          if (response?.i === 414 && response?.d === "High Length Not Acceptable!") {
            console.error("❌ 414 - Request too large!");
            toast.error("Request too large! Please reduce data size.");
            setErrorMessage("High Length Not Acceptable!");
            setTimeout(() => setErrorMessage(""), 3000);
            return;
          }

          // Handle profile
          if (response?.i === 200 && response.d?.profile) {
            setWsData(response.d.profile);
          }

          // Handle alerts
          if (response?.i === 200 && response?.d) {
            const data = typeof response.d === "string" ? JSON.parse(response.d) : response.d;
            if (data && Array.isArray(data.alerts)) {
              setAlertsData(data.alerts);
            }
          }

          // Handle orders
          if (response?.i === 200) {
            const data = typeof response.d === "string" ? JSON.parse(response.d) : response.d;
            if (!data) return;
            if (Array.isArray(data.orders)) {
              setOrdersData(data.orders);
            }
          }

          // Handle positions
          if (response?.i === 200) {
            const posdata = typeof response.d === "string" ? JSON.parse(response.d) : response.d;
            if (!posdata) return;
            if (Array.isArray(posdata.positions)) {
              const sorted = [...posdata.positions].sort((a, b) => {
                if (a.pos === 0 && b.pos !== 0) return 1;
                if (a.pos !== 0 && b.pos === 0) return -1;
                return 0;
              });
              setPositionsData(sorted);
            }
          }

          // Handle single position update
          if (response?.data?.position) {
            const newRow = response?.data?.position;
            setPositionsData((prev) => {
              if (!Array.isArray(prev)) return [newRow];
              const filtered = prev.filter(
                (pos) => pos.trading_symbol?.toUpperCase().trim() !== newRow.trading_symbol?.toUpperCase().trim()
              );
              return [newRow, ...filtered];
            });
          }

          // Handle position event
          if (response?.data?.position_event) {
            const { symbol, unrealized_pnl, ltp } = response?.data?.position_event;
            setTimeout(() => {
              setPositionsData((prev) => {
                if (!Array.isArray(prev)) return prev;
                return prev.map((pos) =>
                  pos.trading_symbol?.toUpperCase().trim() === symbol?.toUpperCase().trim()
                    ? { ...pos, unrealized: Number(unrealized_pnl), ltp: Number(ltp) }
                    : pos
                );
              });
            }, 1);
          }

          // Handle messages
          if (response?.data?.msg) {
            setMessage(response?.data?.msg);
          }

          // Handle balance
          if (response?.d?.balance || response?.data) {
            let balanceArray = null;
            if (response.d?.balance) {
              balanceArray = response.d.balance;
            } else if (response.data) {
              const parsedData = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
              balanceArray = parsedData?.balance;
            }
            const balanceData = Array.isArray(balanceArray) ? balanceArray[0] : balanceArray;
            if (balanceData) {
              setBalance((prev) => ({
                ...prev,
                balance: balanceData.balance,
                account: balanceData.account,
              }));
            }
          }
        };

        socket.onerror = (error) => {
          console.error("❌ WebSocket error:", error);
          resolve(false);
          reconnect();
        };

        socket.onclose = (event) => {
          console.log("⚠️ WebSocket closed:", event);
          if (!token || !window.shouldReconnect) {
            console.log("WebSocket will not reconnect");
            return;
          }
        };
      } catch (err) {
        console.error("❌ WebSocket connection failed:", err);
        resolve(false);
      }
    });
  };

  const reconnect = () => {
    if (reconnectAttemptsRef.current < maxReconnectAttempts) {
      reconnectAttemptsRef.current += 1;
      console.warn(`Attempting reconnect #${reconnectAttemptsRef.current}...`);
      reconnectTimeoutRef.current = setTimeout(() => {
        if (token && window.shouldReconnect) {
          connectWebSocket(token);
        }
      }, 2000);
    } else {
      console.error("Max reconnect attempts reached.");
    }
  };

  const send = (socket, message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(message));
    } else {
      console.warn("⚠️ Socket not open to send", message);
    }
  };

  const logoutCleanup = () => {
    if (socketRef.current) {
      socketRef.current.close();
      socketRef.current = null;
    }
    setWsData(null);
    setBalance(null);
    setAlertsData([]);
    setEventsData([]);
    setErrorMessage("");
    setOrdersData([]);
    setPositionsData([]);
    setMessage("");
  };

  return (
    <UseWebSocketContext.Provider
      value={{
        connectWebSocket,
        wsData,
        balance,
        setBalance,
        setWsData,
        errorMessage,
        logoutCleanup,
        alertsData,
        setAlertsData,
        ordersData,
        setOrdersData,
        positionsData,
        setPositionsData,
        send,
        socketRef,
        isSocketReady,
        setErrorMessage,
        eventsData,
        setEventsData,
        messege,
        setMessage,
        closeWebSocket,
      }}
    >
      {children}
    </UseWebSocketContext.Provider>
  );
}